var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHdmi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "23px",
    viewBox: "0 0 19 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-hdmi") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Specs",
    transform: "translate(-356.000000, -376.000000)",
    stroke: "#010003"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-hdmi",
    transform: "translate(356.000000, 376.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "3.5 7.5 3.5 0.5 15.5 0.5 15.5 7.5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.5,
    y1: 7.5,
    x2: 7.5,
    y2: 4.5,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.5,
    y1: 7.5,
    x2: 11.5,
    y2: 4.5,
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "14.5 22.5 4.5 22.5 4.5 19.5 0.5 14.5 0.5 7.5 18.5 7.5 18.5 14.5 14.5 19.5"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHdmi);
export default __webpack_public_path__ + "static/media/icon-hdmi.7fc19e69e74d9182ed9282d4495b1a08.svg";
export { ForwardRef as ReactComponent };